import { AxiosPromise, AxiosStatic } from "axios";
import {
  Liquidation,
  LiquidationDestination,
  LiquidationInfo,
  LiquidationInput,
  SetLiquidationDestinationInput,
} from "../types/Liquidation";

export const findLiquidationById =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (liquidationId: string): AxiosPromise<Liquidation> =>
    await appAxios.get(`${serverURL}/liquidations/${liquidationId}`, {
      withCredentials: true,
    });

export const getLiquidationInfo =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    dealId: string,
    liquidationId?: string
  ): AxiosPromise<LiquidationInfo | null> =>
    await appAxios.get(`${serverURL}/liquidations/liquidation-info`, {
      params: {
        dealId,
        ...(liquidationId ? { liquidationId } : {}),
      },
      withCredentials: true,
    });

export const createLiquidation =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (liquidation: LiquidationInput): AxiosPromise<void> =>
    await appAxios.post(`${serverURL}/liquidations`, liquidation, {
      withCredentials: true,
    });

export const getLiquidationDestination =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (liquidationId: string): AxiosPromise<LiquidationDestination> =>
    await appAxios.get(
      `${serverURL}/liquidations/${liquidationId}/destination`,
      { withCredentials: true }
    );

export const setLiquidationDestination =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    liquidationId: string,
    destination: SetLiquidationDestinationInput
  ): AxiosPromise<LiquidationDestination> =>
    await appAxios.put(
      `${serverURL}/liquidations/${liquidationId}/destination`,
      destination,
      { withCredentials: true }
    );
